import { riderLocationService } from '../../../services/RiderLocation'
import { ActionsUnion, IRiderLocationObject, IRiderObject } from '../../../types'
import { createAction } from '../helpers'
import * as constants from '../../constants'
import { actionCreators as mapsActionCreators } from '../google_map'
import { actionCreators as tripsActionCreators } from '../trips'
import { riderService } from '../../../services/Rider'

export type IRiderLocationAction = ActionsUnion<typeof actionCreators>
export const actionCreators = {
  //sync action creators
  setRiderLocationQuery: (query: string) => createAction(constants.SET_RIDER_LOCATION_QUERY, query),
  //Async action creators
  ridersCreateLocationRequest: () => createAction(constants.RIDER_CREATE_LOCATION_REQUEST),
  ridersCreateLocationSuccess: (location: IRiderLocationObject) =>
    createAction(constants.RIDER_CREATE_LOCATION_SUCCESS, location),
  ridersCreateLocationFailure: (error: string) => createAction(constants.RIDER_CREATE_LOCATION_FAILURE, error),
  removeRiderLocationRequest: () => createAction(constants.RIDER_REMOVE_LOCATION_REQUEST),
  removeRiderLocationSuccess: (id: string, riderId: string) =>
    createAction(constants.RIDER_REMOVE_LOCATION_SUCCESS, { id, riderId }),
  removeRiderLocationFailure: (error: string) => createAction(constants.RIDER_REMOVE_LOCATION_FAILURE, error)
}

export const saveRiderLocation = (
  riderId: string,
  location: IRiderLocationObject,
  locationType: string,
  locations: IRiderLocationObject[],
  index?: number
) => (dispatch: any) => {
  const { ridersCreateLocationRequest, ridersCreateLocationSuccess, ridersCreateLocationFailure } = actionCreators
  const data = {
    formatted_address: location.fullAddress,
    lat: location.coordinates.lat,
    lng: location.coordinates.lng,
    notes: location.note
  }
  const callback = (error: string | null, response: any) => {
    if (error) {
      return dispatch(ridersCreateLocationFailure(error))
    }
    if (locationType === constants.SET_ORIGIN_TO_TRIP_REQUEST) {
      dispatch(mapsActionCreators.setOrigin(data))
      dispatch(mapsActionCreators.replaceMarkers('origin', [{ type: 'origin', lat: data.lat, lng: data.lng }]))
      dispatch(tripsActionCreators.setOriginToTripRequest(data))
    }
    if (locationType === constants.SET_DESTINATION_TO_TRIP_REQUEST) {
      dispatch(mapsActionCreators.setDestination(data))
      dispatch(
        mapsActionCreators.replaceMarkers('destination', [{ type: 'destination', lat: data.lat, lng: data.lng }])
      )
      dispatch(tripsActionCreators.setDestinationToTripRequest(data))
    }
    if (locationType === constants.SET_ADDITIONAL_STOP_TO_TRIP_REQUEST) {
      const dataWithIndex = {
        ...data,
        index
      }
      dispatch(mapsActionCreators.setAdditionalStop(dataWithIndex))
      dispatch(
        mapsActionCreators.replaceMarkers('additionalStop', [
          { type: 'additionalStop', lat: data.lat, lng: data.lng, index }
        ])
      )
      dispatch(tripsActionCreators.setAdditionalStopToTripRequest(dataWithIndex))
    }
    return dispatch(ridersCreateLocationSuccess(response))
  }
  dispatch(ridersCreateLocationRequest())
  return saveLocation(riderId, location, locationType, locations, callback)
}

async function saveLocation(
  riderId: string,
  location: IRiderLocationObject,
  locationType: string,
  locations: IRiderLocationObject[],
  callback: (error: any, data?: any) => void
): Promise<any> {
  let response
  try {
    if (location.id) {
      response = await riderLocationService.updateRiderLocation(riderId, location)
    } else {
      response = await riderLocationService.createRiderLocation(riderId, location)
    }
  } catch (err) {
    return callback(err)
  }
  return callback(null, response)
}

export const createLocation = (riderId: string, location: IRiderLocationObject) => (dispatch: any) => {
  const { ridersCreateLocationRequest, ridersCreateLocationSuccess, ridersCreateLocationFailure } = actionCreators
  dispatch(ridersCreateLocationRequest())
  return riderLocationService.createRiderLocation(riderId, location).then(
    (riderLocation: IRiderLocationObject) => {
      dispatch(ridersCreateLocationSuccess(riderLocation))
      return riderLocation
    },
    ({ data }) => {
      dispatch(ridersCreateLocationFailure(data))
      setTimeout(() => {
        dispatch(ridersCreateLocationFailure(''))
      }, 5000)
      throw new Error(data)
    }
  )
}

export function removeLocation(riderId: string, id: string) {
  const { removeRiderLocationRequest, removeRiderLocationSuccess, removeRiderLocationFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(removeRiderLocationRequest())
    return riderLocationService.removeRiderLocation(id).then(
      () => {
        dispatch(removeRiderLocationSuccess(id, riderId))
      },
      ({ data }) => {
        dispatch(removeRiderLocationFailure(data))
        setTimeout(() => {
          dispatch(removeRiderLocationFailure(''))
        }, 5000)
        throw new Error(data)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/state/actions/rider-locations/index.ts